<template>
	<div>
		<span>hu?</span>
	</div>
</template>

<script>
const auth = require("@/utils/auth");
const logger = require("@/utils/logger");
import router from "../../router";

export default {
  mounted() {
    auth.detectAuth0Callbacks(
      function(loggedIn, appRedirectTo) {
        if (loggedIn) {
          router.push(appRedirectTo);
        } else {
          console.error("Not logged in after callback!")
          // TODO redirect /
        }
      },
      function(error_description) { // login error
        logger.log('error_description: ' + error_description)
        router.push({
          name: "login-callback",
          params: { reason: error_description }
        });
      }
    );
  }
};
</script>

<style scoped>
html,
body,
div {
  display: flex;

  min-height: 100%;
  height: 100%;
  min-height: 100vh;

  align-items: center;
  justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/components/misc/PageNotFound.vue